const POSTBACK_SETTING_TYPE = {
    VIEW: 1 << 0,
    MODIFY: 1 << 1,
    CREATE: 1 << 2,
    LOGS: 1 << 3
}

export default POSTBACK_SETTING_TYPE;